import { render } from "./PointDesProduitsVenduPage.vue?vue&type=template&id=6f997efb&ts=true"
import script from "./PointDesProduitsVenduPage.vue?vue&type=script&lang=ts"
export * from "./PointDesProduitsVenduPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__